<template>
    <div class="coupon">
        <el-row style="margin-top:20px;">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-col :span="15" style="margin-bottom:20px">
                        <el-button type="primary" icon="el-icon-back" @click="goBack()">返回列表</el-button>
                    </el-col>
                    <el-table :data="tableData" style="width: 100%" border>
                        <el-table-column :resizable="false" type="index" label="序号" width="50" align="center"></el-table-column>
                        <el-table-column :resizable="false" prop="bannerName" label="轮播图名称" align="center"></el-table-column>
                        <el-table-column :resizable="false" prop="bannerUrl" label="缩略图" align="center">
                            <template slot-scope="scope">
                                <el-image
                                    v-if="scope.row.bannerUrl !== null"
                                    style="width: 50px; height: 50px"
                                    :src="scope.row.bannerUrl"
                                    @click="check(scope.row)"
                                ></el-image>
                                <span v-else>暂无图片</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="创建时间" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.createTime | moment('YYYY-MM-DD HH:mm:ss') }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <el-button @click="$refs.edit.getMerchantInfo(scope.row.id)" type="text" size="small">修改</el-button>
                                <!-- <el-button @click="checkModal(scope.row)" type="text" size="small">查看</el-button> -->
                                <el-button v-if="scope.row.whetherShow == 0" @click="startModal(scope.row)" type="text" size="small"
                                    >启用</el-button
                                >
                                <el-button v-if="scope.row.whetherShow == 1" @click="disabledModal(scope.row)" type="text" size="small"
                                    >禁用</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页区域 -->
                    <!-- <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchInfo.pageNum"
                        :page-size="searchInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination> -->
                </el-card>
            </el-col>
        </el-row>
        <!-- 弹框 -->
        <!-- <el-dialog title="修改轮播图" :visible.sync="editDialogFormVisible" width="800px"  :close-on-click-modal="false" >
            <edit v-bind:editData="editData" @dialogEdit="dialogFormEdit"></edit>
        </el-dialog> -->
             <edit ref="edit" @getSysInfoList="getSysInfoList"></edit>
             <el-dialog
  title="轮播图"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
  <div class="check">
     <img  :src="imageurl" class="image"/> 
  </div>
</el-dialog>
    </div>
</template>
<script>
import edit from './swiperChildren/edit.vue';
export default {
    data() {
        return {
            // 查询参数
            searchInfo: {
                // 默认请求第一页
                // pageNum: 1,
                // 默认请求10条数据
                // pageSize: 10,
                merchantId: ''
            },
            id: '', //商家id
            // 日期
            date: null,
            // 数据列表
            tableData: [],
            // 数据总数
            total: 0,
            checkData: '',
            editData: {},
            editDialogFormVisible: false ,//修改
            dialogVisible:false,
            imageurl:''
        };
    },
    created() {
        // 获取数据列表
        console.log(this.$route.query);
        //this.searchInfo.merchantId = this.$route.query.id;
        //this.id = this.$route.query.id;
        console.log(this.id);
        //this.getSysInfoList();
    },
    components: { edit },
    methods: {
        async getSysInfoList() {
            let that = this;
            const res = await that.$axios.post('banner/list', this.searchInfo);
            console.log(res);
            if (res.data.code == 0) {
                that.tableData = res.data.data;
                console.log(that.tableData);

                console.log(that.tableData);
            }
        },
        handleSizeChange(pageSize) {
            this.pageNum = 1;
            this.searchInfo.pageSize = pageSize;
            this.getSysInfoList();
        },

        handleCurrentChange(pageNum) {
            this.searchInfo.pageNum = pageNum;
            this.getSysInfoList();
        },
        //修改
        editModal(data) {
            this.editData.merchantId = this.id;
            this.editData.id = data.id;
            console.log(this.editData);
            this.editDialogFormVisible = true;
        },
        dialogFormEdit(data) {
            console.log(data);
            this.editDialogFormVisible = data;
            this.getSysInfoList();
        },
        //启用
        async startModal(data) {
            const res = await this.$axios.post('banner/toUseBanner', {
                id: data.id
            });
            console.log(res);
            if (res.data.code == 0) {
                this.$message.success('启用成功');
                this.getSysInfoList();
            } else {
                this.$message.error('启用失败');
            }
        },
        //禁用
        async disabledModal(data) {
            const res = await this.$axios.post('banner/toUnUseBanner', {
                id: data.id
            });
            console.log(res);
            if (res.data.code == 0) {
                this.$message.success('禁用成功');
                this.getSysInfoList();
            } else {
                this.$message.error('禁用失败');
            }
        },
        check(data){
         let that=this
         that.dialogVisible=true
         that.$axios
                .post('banner/getData', {
                    id: data.id
                })
                .then(res => {
                    console.log(res);
                    if (res.data.code == 0) {
                        that.imageurl = res.data.data.bannerUrl;
                        that.$message.success('获取轮播图成功');
                    } else {
                        that.$message.error(res.data.data);
                    }
                });
        },
        handleClose(){
        this.dialogVisible=false
        },
        //查看图片
        checkModal(data) {
            this.$router.push({
                name: 'swiperCheck',
                query: {
                    id: data.id
                }
            });
        },
        goBack() {
            this.$router.push('/BusManage-Detail');
        }
    }
};
</script>
<style lang="less" scoped>
.el-table {
    margin-top: 20px;
}
.el-pagination {
    margin-top: 20px;
    text-align: center;
}
.check{
   margin:  0 auto;
   text-align: center;  
}
.check .image{
    width: 400px;
    height: 400px;
    margin:  0 auto;
}
</style>
